var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"align-items-center justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"lg":"8"}},[_c('h4',{staticClass:"text-help my-4"},[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }